import React from 'react';

interface PageContainerProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ title, subtitle, actions, children, className = '' }) => {
  return (
    <div className={`max-w-6xl mx-auto px-6 lg:px-8 py-8 ${className}`}>
      {(title || actions) && (
        <div className="mb-8 flex items-start justify-between gap-4">
          <div className="min-w-0">
            {title && (
              <h1 className="text-3xl font-semibold tracking-tight text-primary-900 leading-tight">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-sm text-primary-500 mt-1.5 max-w-2xl leading-relaxed">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex-shrink-0 flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className="space-y-6">{children}</div>
    </div>
  );
};

export default PageContainer;
